<div class="pb-3 px-10">
  <div class="flex justify-between bg-bgCarvest bg-(--comp-app-bg)">
    <div class="hidden sm:flex">
      <div class="flex gap-3">
        <img
          alt="Dynamic Joint"
          class="cursor-pointer w-36"
          src="assets/icons/logo-dynamic-einteligent.svg"
          (click)="this.goToUrl(['/home'], {})"
        />

        @if (currentSection) {
          <div class="text-base font-semibold text-(--brand-gray-dark) flex items-center gap-1">
            {{ currentSection }}
          </div>
          @for (button of menuCarvesrt; track button) {
            @if (button.menu.length) {
              <button
                (click)="isTab = button.isTab; menu = button.menu; title = button.description ?? ''"
                [matMenuTriggerFor]="routerMenu"
                matButton
                class="w-auto! px-4! m-auto"
                [matTooltip]="button.description | translate"
              >
                <div class="flex items-center gap-1">
                  @if (button.icon) {
                    <mat-icon class="w-8! h-8! text-3xl!">{{ button.icon }}</mat-icon>
                  }
                </div>
              </button>
            } @else {
              <button
                (click)="this.goToUrl([button.url ?? '/'], {})"
                matButton
                class="w-auto! px-4! m-auto"
                [matTooltip]="button.description | translate"
              >
                <div class="flex items-center gap-1">
                  @if (button.icon) {
                    <mat-icon class="w-8! h-8! text-3xl!">{{ button.icon }}</mat-icon>
                  }
                </div>
              </button>
            }
          }
        }
      </div>
    </div>

    <div class="flex justify-center items-center gap-4">
      <mat-icon [matMenuTriggerFor]="userProfile" class="w-8! h-8! text-3xl! cursor-pointer"
        >account_circle</mat-icon
      >

      <div class="flex gap-4">
        <div class="text-general">{{ 'headers.welcome' | translate }}</div>
        <div class="text-base font-semibold">|</div>
        <div class="text-general">{{ name }}</div>
      </div>
    </div>
  </div>
</div>
<mat-menu #userProfile="matMenu">
  <div class="flex justify-center items-center gap-4" (click)="logout()" mat-menu-item>
    <mat-icon class="w-7! h-7! text-3xl! cursor-pointer">close</mat-icon>
    {{ 'headers.logout' | translate }}
  </div>
</mat-menu>

<mat-menu #routerMenu="matMenu" class="text-(--color-text-primary)!">
  <div
    class="text-general-subtitle flex justify-center items-center p-1 border-b border-(--brand-gray-dark)"
  >
    {{ title | translate }}
  </div>
  @for (button of menu; track button) {
    <button mat-menu-item (click)="navigateMenu(button, $index, isTab)">
      <span class="text-(--color-text-primary)!">{{ button.description | translate }}</span>
    </button>
  }
</mat-menu>
